import { client } from "@/http/client"

import { IPagingResponse, IRequestParams, IResponse } from "@/types/api"
import { IDownloadDocument } from "@/types/IDownloadDocument"
import { IDispatcherOrder, IOrderCoordinateTime } from "@/types/IOrder"
import { ITableColumn } from "@/types/ui"


export const getDispatcherTimeCoordinateById = (id: number): Promise<IResponse<IDispatcherOrder>> =>
  client.get(`/DispatcherTimeCoordinate/${id}`)

export const getDispatcherTimeCoordinate = (
  params: IRequestParams
): Promise<IPagingResponse<IDispatcherOrder>> =>
  client.get("/DispatcherTimeCoordinate", {
    params
  })


export const getDispatcherTimeCoordinateCount = () : Promise<IResponse<number>> => 
  client.get("/DispatcherTimeCoordinate/count")
  
export const getDispatcherTimeCoordinateExcel = (params: IRequestParams, columns?: ITableColumn<IDispatcherOrder>[]):
  Promise<IResponse<IDownloadDocument>> => client.post("/DispatcherTimeCoordinate/Excel",
  columns, {
  params
})

export const coordinateOrderTime = (
  body: IOrderCoordinateTime
): Promise<IResponse<boolean>> => client.put("/DispatcherTimeCoordinate/coordinate-time", body)